import axiosInstance from './axiosServicesVisit';

// AJOUT DU PRÉFIXE /v1
const API_PREFIX = '/v1';

// Activer/Désactiver le mode urgence (Admin seulement)
export const toggleEmergencyAccess = (enabled) => {
  return axiosInstance.patch(`${API_PREFIX}/settings/emergency-access`, { enabled });
};

// Vérifier l'état (Utilisé pour afficher le switch dans l'admin)
export const getEmergencyAccessStatus = () => {
  return axiosInstance.get(`${API_PREFIX}/settings/emergency-access`);
};